import React from 'react';
import { KitFormInfoText, KitFormLabel } from './KitFormControls';
import KitInput, { KitInputProps } from './KitInput';

export interface KitFormInputProps extends KitInputProps {
  id: string;
  label?: string;
  labelAs?: 'label' | 'h4';
  required?: boolean;
}

export const KitFormInput = React.forwardRef<HTMLInputElement, KitFormInputProps>(
  ({ id, label, labelAs, required, infoMessage, ...rest }, ref) => {
    const infoTextId = `${id}Info`;
    return (
      <>
        {label && <KitFormLabel required={required} text={label} htmlFor={id} as={labelAs} />}
        <KitInput
          id={id}
          name={id}
          data-qa-id={id}
          ref={ref}
          aria-describedby={infoMessage ? infoTextId : undefined}
          {...rest}
        />
        {infoMessage && (
          <KitFormInfoText
            text={infoMessage}
            isError={rest.isError}
            id={infoTextId}
            data-qa-id={infoTextId}
            aria-live='polite'
          />
        )}
      </>
    );
  }
);
